// Payroll payer default for new Temp Staff: Candidate and Field Staff start with "Cheque - 44hrs".
// Outsourced Staff get no default (their payer/agency is chosen manually).
// Matched by payer name because payer ids differ per database.

export const DEFAULT_PAYER_TYPES = ["candidate", "fieldstaff"];
export const DEFAULT_TEMP_PAYER_NAME = "Cheque - 44hrs";

export const usesDefaultPayer = (type) =>
  DEFAULT_PAYER_TYPES.includes(String(type || "").trim().toLowerCase());

export const findDefaultPayerId = (payers = []) => {
  const match = (Array.isArray(payers) ? payers : []).find(
    (p) => String(p?.name || "").trim().toLowerCase() === DEFAULT_TEMP_PAYER_NAME.toLowerCase(),
  );
  return match ? String(match.payer_id || match.id) : "";
};

/**
 * Payer value to use after the Type changes (create forms).
 * - Candidate / Field Staff: the default payer
 * - Outsourced Staff: clear the auto-filled default (it isn't an agency), keep any manual choice
 */
export const payerForTypeChange = (type, currentPayerId, payers) => {
  const defaultId = findDefaultPayerId(payers);
  if (usesDefaultPayer(type)) return defaultId || currentPayerId || "";
  if (defaultId && String(currentPayerId || "") === defaultId) return "";
  return currentPayerId || "";
};
